import {Injectable} from '@angular/core';
import {HttpClient, HttpEvent, HttpEventType} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {environment} from "../../environments/environment";

@Injectable()
export class ImageService {

  constructor(private http: HttpClient) {
  }

  uploadImage(imageFile: File, type: ImageSubjectType, id: number): Observable<any> {

    const apiUrl = `${environment.backendApi}api/${type.uploadURLPart}/${id}/image`

    console.log(`uploading file for type=${type.uploadURLPart} id=${id}`, imageFile)

    return this.http.post(apiUrl, imageFile, {
      headers: {
        'Content-Type': imageFile.type
      },
      reportProgress: true,
      observe: 'events'
    }).pipe(
      map((event: HttpEvent<any>) => {
        switch (event.type) {
          case HttpEventType.UploadProgress:
            const progress = Math.round(100 * event.loaded / (event.total || event.loaded));
            return {status: 'progress', progress};
          case HttpEventType.Response:
            return {status: 'complete', data: event.body};
          default:
            return {status: 'other'};
        }
      })
    );
  }

  getImageUsingREST(imageUrl: string): Observable<Blob> {
    return this.http.get(imageUrl, {responseType: 'blob'});
  }

  getImageUrl(type: ImageSubjectType, subjectId: number): string {
    return environment.backendApi + "api/Sync/Image/" + this.createImageId(type, subjectId) + "_" + Date.now().valueOf()
  }

  createImageId(type: ImageSubjectType, subjectId: number): string {
    return `${type.imageIdPart}_${subjectId}`;
  }
}

export class ImageSubjectType {
  public constructor(public readonly uploadURLPart: string, public readonly imageIdPart: string) {
  }

  public static readonly TRACTOR = new ImageSubjectType("Tractors", "tractor");
  public static readonly TRAILER = new ImageSubjectType("Trailers", "trailer");
}


